// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'apps' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di apps.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/apps.sr-Cyrl-RS.meta.json.
import type { enUS } from './apps'

export const srCyrlRS: typeof enUS = {

  // Apps wave 1 (Annex R): container podman gestiti — supervisionati dal
  // worker su un nodo dichiarato; immagine = lockfile branch@digest (Annex Q)
  // con policy pinned/tracking; attacco L3 untagged con IP statico.
  apps: {
    title: 'Апликације',
    create: 'Креирај апликацију',
    createTitle: 'Креирајте апликацију',
    editTitle: 'Измените апликацију',
    name: 'Име',
    nameHint: 'DNS-1123, јединствено унутар scopea — непроменљиво након креирања.',
    node: 'Чвор',
    nodeHint: 'Члански чвор који је служи — експлицитни placement (scheduler стиже касније).',
    image: 'Слика',
    editImageHint: 'Нова референца се поново разрешава кроз матичне податке — гест pina/rollbacka.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest се помера само на команду.',
    policyTrackingHint: 'Котрља се аутоматски када refresh помери branch.',
    archMovePolicy: 'Cross-arch премештање',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Шта се дешава ако се app премести на ноде друге архитектуре: refuse одбија премештање, reresolve изнова разрешава lockfile са brancha на новој arch — садржај се мења, и одговор именује промену digesta.',
    network: 'Мрежа',
    networkHint: 'Untagged L3 прикључак: fabric логичка мрежа (препоручена — gateway/DNS из њеног јединог извора), overlay, или голи хост bridge (не препоручује се).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'хост bridge:',
    ipAssignment: 'Додела IP адресе',
    ipStatic: 'Статичка',
    ipAuto: 'Аутоматска (IPAM)',
    ipAssignmentHint_static: 'Адресу дајете ви, сада.',
    ipAssignmentHint_auto: 'IPAM бира слободну адресу из опсега мреже резервисаних за TVirt.',
    bridgeDiscouraged: 'Голи хост bridge — НЕ ПРЕПОРУЧУЈЕ СЕ: TVirt не зна ништа о његовом адресирању, па се gateway и DNS морају дати ручно. Препоручени пут је fabric логичка мрежа.',
    ip: 'IP',
    ipHint: 'Статичка IPv4 адреса унутар подмреже прикључка.',
    ipCidrHint: 'У CIDR облику на голом bridgeu (нпр. 192.168.1.10/24) — нема одакле извести префикс.',
    gateway: 'Gateway',
    gatewayManualHint: 'Ручно — голи bridge ништа не изводи.',
    dnsServers: 'DNS сервери',
    dnsManualHint: 'Ручно, одвојени зарезом — бар један.',
    rootKind: 'Root',
    rootEphemeral: 'ефемеран',
    rootPersistent: 'трајан',
    rootEphemeralHint: 'Поново се креира из слике при сваком поновном креирању; живи на кластерском ефемерном storageu.',
    rootEphemeralHintNamed: 'Поново се креира из слике при сваком поновном креирању; живи на кластерском ефемерном storageu ({name}).',
    rootPersistentHint: 'Преживљава restarte; живи на storageu који изаберете.',
    rootStorage: 'Root storage',
    editRootStorageHint: 'Root се поново рендерује на новом poolu — постојећи подаци се НЕ премештају сами.',
    volumes: 'Волумени',
    volumeAdd: 'Додај волумен',
    volumeName: 'Име',
    volumeMountPath: 'Путања монтирања',
    volumeKind: 'Тип',
    volumeStorage: 'Storage',
    devices: 'Уређаји',
    deviceClassHint: 'Тражи се KLASA (ознака gpu-device или usb-device), никада одређени уређај: пријављени чвор мора имати неки означен за Apps. Више Apps може користити исти уређај — контејнер га дели, не одузима га домаћину.',
    deviceSlot: 'Slot',
    deviceTag: 'Ознака',
    deviceValue: 'Класа',
    deviceUnresolved: 'тренутно се ништа не разрешава',
    noDeviceTags: 'Још нема ознаке врсте gpu-device или usb-device: направи је и додели уређајима означеним за Apps.',
    env: 'Окружење',
    envHint: 'Један КЉУЧ=вредност по реду.',
    secretEnvTitle: 'Тајне променљиве',
    secretEnvNotice: 'Тајна вредност се више никада не враћа из API-ја: нико је не чита поново, чак ни онај ко ју је уписао. У checkpointu путује запечаћена masterpassom, па ће враћање без masterpassa тражити да је поново упишете.',
    secretEnvPromote: 'Учините тајном једну од горе уписаних променљивих:',
    secretEnvAdd: 'Додај тајну променљиву',
    secretEnvName: 'Име',
    secretEnvValue: 'Вредност',
    secretEnvKept: 'сачувана — оставите празно да је не мењате',
    secretEnvWithdrawWarning: 'Да бисте престали да третирате као тајну променљиву која то већ јесте, упишите јој нову вредност: само скидање ознаке било би начин да се ПРОЧИТА оно што не излази из storea. Уклањање променљиве је, напротив, брише.',
    secretEnvChip: 'тајно',
    startNow: 'Покрени одмах (иначе се апликација креира заустављена)',
    deletePersistentIntro: 'Ова апликација има трајне податке — изаберите шта ће бити са њима:',
    deleteKeepData: 'Задржи податке (директоријуми остају на својим сторагеима, напуштени)',
    deletePurgeData: 'Обриши и податке',
    phase: 'Фаза',
    phase_running: 'У току',
    phase_stopped: 'Заустављена',
    phase_error: 'Грешка',
    phase_unknown: 'Непозната',
    desiredState: 'Жељено',
    wantedRunning: 'у току',
    wantedStopped: 'заустављена',
    start: 'Покрени',
    stop: 'Заустави',
    restart: 'Рестартуј',
    refreshImage: 'Освежи слику (усвоји нови @current)',
    logs: 'Logovi',
    logsTitle: 'Logovi',
    logsEmpty: 'Нема ухваћеног излаза.',
    shell: 'Схелл',
    shellTitle: 'Схелл',
    shellUnavailable: 'App није покренута — схелл захтева жив контејнер. Њени logovi се читају у било ком стању.',
    shellConnect: 'Повежи',
    shellDisconnect: 'Прекини везу',
    shellExited: 'Сесија је завршена са излазним кодом {code}.',
    shellEndedWithoutStatus: 'Сесија је завршена без излазног статуса: {reason}',
    shellRevoked: 'Тицкет сесије више није важећи — истекао је, или је пријава која га је отворила опозвана.',
    shellHint: 'Кликни на црно поље и куцај: тастери стижу до контејнера. Ctrl+C и стрелице раде; exit затвара схелл.',
    shellStatus: {
      connecting: 'Повезивање…',
      connected: 'Повезана',
      ended: 'Завршена'
    },
    deleteRunningError: 'За {name} је жељено стање „у току“ — прво је зауставите.',

    // Dialog standard (round #156): i tab del dettaglio e i campi contract
    // mancanti — ogni campo dell'App visibile, lucchetti col perché.
    tabs: {
      general: 'Опште',
      image: 'Слика',
      network: 'Мрежа',
      storage: 'Storage',
      devices: 'Уређаји',
      observed: 'Посматрано'
    },
    attachment: 'Прикључак',
    runningDigest: 'Digest у току',
    lastError: 'Последња грешка',
    reportObservedAt: 'Последњи извештај workera',
    desiredStateLock: 'Њиме управљају акције Покрени/Заустави — никада директна измена.',
    ipEditDisabledHint: 'Изменљиво само уз статичку доделу.',
    derivedFromNetworkHint: 'Изведено из јединог извора мреже — ручно само на голом bridgeu са статичком IP адресом.',
    ephemeralUnset: 'није конфигурисано',
    ephemeralMissing: 'Ефемерни storage за апликације није конфигурисан — креирање апликације са ефемерним деловима (root или волумени) се одбија док га не подесите.',
    ephemeralCurrent: 'Ефемерни storage за апликације: {name}',
    ephemeralMissingCreate: 'Ова апликација има ефемерне делове, али ефемерни storage за апликације није подешен — креирање ће бити одбијено. Прво га подесите са банера странице Апликације.',
    setEphemeral: 'Подеси ефемерни storage',
    changeEphemeral: 'Промени ефемерни storage',
    setEphemeralTitle: 'Подесите ефемерни storage за апликације',
    changeEphemeralTitle: 'Промените ефемерни storage за апликације',
    ephemeralStorageHint: 'ПОДРАЗУМЕВАНО на нивоу кластера: dir-like pool у којем живе ефемерни rootovi и ефемерни волумени сваке апликације, осим ако апликација не декларише сопствени override. Промена се не примењује у ходу и ништа не рестартује: важи од следећег покретања сваке апликације — ефемерни подаци се не премештају.',
    ephemeralPool: 'Storage pool',
    ephemeralOverride: 'Ефемерни storage (override по апликацији)',
    ephemeralOverrideInherit: 'Наслеђује подразумевано за кластер',
    ephemeralOverrideInheritNamed: 'Наследи подразумевану вредност кластера ({name})',
    ephemeralOverrideHint: 'Pool по апликацији за ефемерни root и волумене — оставите празно да наследи подразумевану вредност кластера. Промена се не примењује у ходу и ништа не рестартује: важи од следећег покретања (ефемерни подаци се поново рађају празни на новом poolu) и захтева дозволу app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Све гране',
    imageBranchHint: 'Сужава слике на оне које именује ова грана; без гране виде се све слике спремишта.',
    imageDigestHint: 'Садржај: бира се из табеле digesta, која носи његово порекло и архитектуру. Иста грана нуди по један за архитектуру и нису заменљиви.',
    imageLockfile: 'Разрешена референца',
    imageNoImages: 'Нема слика у кешу за ово спремиште — преузми једну из OCI слика.',
    imageHeadNotCached: 'није у кешу — преузима се при покретању',
    imageNoRegistries: 'Није регистровано ниједно спремиште: региструј једно да би могао да изабереш слику.',
    imageChosenHint: 'Слика се бира каскадом у дијалогу измене: референца се никада не куца ручно.',
    registerRepositoryHint: 'Регистровање ништа не преузима: чини спремиште праћеним, да би се слика могла изабрати без напуштања овог дијалога.',
    registerRepositoryBranchHint: 'Опционо: прва грана коју треба пратити (нпр. латест).',
    registerRepositoryElsewhere: 'Тражено спремиште није регистровано: регистровање се ради у одељку OCI слике, од стране некога ко има дозволу.'
  },

  // Template CT (round K2 #63): gli oggetti CT MATERIALIZZATI — l'import da
  // catalogo è l'unico ingresso; i file si caricano dentro i cataloghi.
  cts: {
    createAction: 'Креирај CT',
    createTitle: 'Креирајте контејнер из шаблона',
    createError: 'Контејнер није креиран',
    template: 'CT шаблон',
    noTemplates: 'Још нема CT шаблона — увезите један у одељку CT шаблони',
    resources: 'Ресурси',
    node: 'Чвор',
    phase: {
      defined: 'Никада упаљен',
      materializing: 'У материјализацији',
      ready: 'Спреман',
      starting: 'Покреће се',
      running: 'У току',
      stopping: 'Зауставља се',
      stopped: 'Заустављен',
      deleting: 'Брише се',
      error: 'У грешци'
    },
    actions: {
      start: 'Покрени',
      stop: 'Заустави',
      restart: 'Рестартуј',
      markTemplate: 'Унапреди у CT шаблон',
      error: 'Акција је одбијена'
    },
    markTemplate: {
      confirmTitle: "Унапредити '{name}' у CT шаблон?",
      confirmBody: 'Контејнер напушта ову листу и прелази међу CT шаблоне, одмах спреман да ствара нове CT-ове. Његови метаподаци остају изменљиви, и у сваком тренутку га можете вратити у CT.',
      confirm: 'Унапреди',
      moved: "'{name}' је сада CT шаблон — наћи ћете га у одељку CT шаблони."
    },
    stopCause: {
      api: 'Заустављен преко TVirta',
      'ct-exit': 'Контејнер је изашао сам од себе',
      'host-reboot': 'Умро са restartom чвора',
      'start-failed': 'Покретање није успело — грешка задатка каже шта недостаје и како се поправља'
    },

    console: 'Конзола',
    consoleUnavailable: 'Контејнер није покренут — конзоли је потребан жив контејнер. Његови logovi се пак читају у било ком стању.',
    consoleNoTemplate: 'Шаблон никада не ради, па нема конзолу: креирајте из њега CT и отворите његову.',
    consoleConnect: 'Повежи',
    consoleDisconnect: 'Прекини везу',
    consoleReconnect: 'Повежи поново',
    consoleTakenBy: 'Ову конзолу је преузео други оператер ({user}). Једна конзола по контејнеру: поновно повезивање је враћа вама.',
    consoleHint: 'Кликните на црно поље и куцајте: тастери стижу до контејнера. Ctrl+C и стрелице раде.',
    consoleEndpointDown: 'Приступна тачка конзоле не може да се отвори на чвору који опслужује container: {cause}',
    shell: 'Схелл',
    shellTitle: 'Схелл',
    shellUnavailable: 'Container није покренут — схелл захтева жив container. Његови logovi се читају у било ком стању.',
    shellNoTemplate: 'Template се никад не извршава, па нема схелл: направи CT од њега и отвори његов.',
    shellConnect: 'Повежи',
    shellDisconnect: 'Прекини везу',
    shellExited: 'Сесија је завршена са излазним кодом {code}.',
    shellEndedWithoutStatus: 'Сесија је завршена без излазног статуса: {reason}',
    shellRevoked: 'Тицкет сесије више није важећи — истекао је, или је пријава која га је отворила опозвана.',
    shellHint: 'Кликни на црно поље и куцај: тастери стижу до контејнера. Ctrl+C и стрелице раде; exit затвара схелл.',
    shellStatus: {
      connecting: 'Повезивање…',
      connected: 'Повезана',
      ended: 'Завршена'
    },
    rootPassword: 'Лозинка roota',
    rootPasswordHint: 'Уписује се једном у копирани rootfs (као hash, више се не приказује). Слике дистрибуција немају лозинку roota: без ње је схелл једини улаз.',
    sshKeys: 'Јавни SSH кључеви roota',
    sshKeysHint: 'Један јавни OpenSSH кључ по реду, у root/.ссх/authorized_keys.',
    consoleStatus: {
      connecting: 'Повезивање…',
      connected: 'Повезана',
      reconnecting: 'Поновно повезивање…'
    },
    logs: 'Logovi',
    logsTitle: 'Logovi',
    logsEmpty: 'Нема ухваћеног излаза.',
    logsSource: 'Који log',
    logsSourceConsole: 'Конзола inita контејнера — зашто се сервис унутра није покренуо',
    logsSourceSupervisor: 'Надзорник liblxc — зашто контејнер никада није ни стигао да се покрене',
    logsNeverStarted: 'Никада није покренут, па још нема ништа забележено — покрените га и logovi ће бити ту чак и ако покретање не успе.',
    logsNoTemplate: 'Шаблон никада не ради, па никада ништа није ни забележио.',
    logsError: 'Logovi нису ухваћени',

    // Dialog standard (round #156): i tab del dettaglio condivisi dalle
    // liste CT e Template CT, più i lucchetti col perché.
    tabs: {
      general: 'Опште',
      hardware: 'Хардвер',
      network: 'Мрежа',
      provenance: 'Порекло'
    },
    templateFlag: 'CT шаблон',
    templateLock: 'Мења се само акцијама Унапреди / Врати у CT — никада директна измена.',
    sourceLock: 'Порекло, забележено при настанку — никада се не преписује; мртав извор оставља голу референцу.',
    storageLock: 'Фиксирано при креирању — премештање rootfs стабла је будући round.',
    startedAt: 'Покренут',
    lastStop: 'Последње заустављање',
    editNicsTitle: 'Измените мреже',
    nicDisconnected: 'откачена'
  },
  ctTemplates: {
    title: 'CT шаблони',
    importAction: 'Увези из каталога',
    importTitle: 'Увезите CT шаблон из каталога',
    importSubmit: 'Увези',
    importError: 'Увоз је одбијен',
    importHint: 'Материјализација копира rootfs на изабрани storage — датотека каталога остаје нетакнута. Да бисте додали нове датотеке, прво их отпремите у каталог.',
    sourceFile: 'Датотека CT шаблона',
    sourceFileHint: 'Датотеке ct-rootfs изабраног каталога, само оне спремне',
    noFiles: 'Нема спремне ct-rootfs датотеке у овом каталогу — прво отпремите једну са странице каталога',
    source: 'Изворна датотека',
    rootfsStorage: 'Storage за rootfs',
    rootfsStorageHint: "Где живи распаковано rootfs стабло — storage заснован на filesystemu, са довољно слободног простора за распаковану величину плус око 1 GiB резерве (у супротном увоз не успева).",
    resources: 'Ресурси',
    cores: 'vCPU',
    memoryMiB: 'Меморија (MiB)',
    cpuLimit: 'CPU лимит',
    cpuLimitHint: 'Еквиваленти хост језгара (нпр. 1.5); празно = без ограничења',
    cpuUncapped: 'без ограничења',
    cpuWeight: 'CPU тежина',
    hostname: 'Hostname',
    hostnameHint: 'Празно = име самог CT-а',
    nameservers: 'DNS nameserveri',
    dnsHint: 'Одвојени зарезом; празно = наслеђују се од хоста',
    searchDomains: 'DNS домени претраге',
    dnsInherited: 'Наслеђено од хоста',
    networks: 'Мреже',
    nicSlot: 'NIC slot',
    phase: {
      materializing: 'У материјализацији',
      ready: 'Спреман',
      deleting: 'Брише се',
      error: 'Грешка'
    },
    exportAction: 'Извези у каталог',
    exportTitle: 'Извезите у каталог',
    exportSubmit: 'Извези',
    exportError: 'Извоз је одбијен',
    exportHint: 'Пакује материјализовани rootfs у НОВУ ct-rootfs датотеку у изабраном каталогу — шаблон остаје нетакнут.',
    exportName: 'Име датотеке',
    exportNameHint: 'Празно = <template>-export-<n>',
    markCt: {
      action: 'Врати у CT',
      confirmTitle: "Вратити '{name}' у CT?",
      confirmBody: 'Шаблон напушта ову листу и враћа се у листу CT-ова, поново га је могуће покренути. Док га поново не унапредите, из њега се не могу креирати нови CT-ови.',
      confirm: 'Врати у CT',
      moved: "'{name}' је поново обичан CT — наћи ћете га у листи CT-ова."
    }
  },

  // OCI wave 1 (Annex Q — il modello tag-come-branch): un tag OCI è un branch
  // (puntatore mobile), il digest è il commit; refresh = "git fetch",
  // pull = risolvi ADESSO, scarica QUEL digest.
  oci: {
    registriesTitle: 'OCI registryji',
    imagesTitle: 'OCI слике',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Генерички',
    providerImmutableHint: 'Provider је непроменљив након креирања — другачији provider је нови registry.',
    url: 'URL',
    urlHintPreset: 'Унапред попуњен према provideru — мењајте само за мирроре.',
    urlHintRequired: 'Обавезан за генерички registry: базни https:// URL.',
    urlHintEcr: 'Обавезан: ECR endpointi су по налогу/по региону — preset не постоји.',
    credential: 'Акредитив',
    credentialNone: 'Анонимни приступ',
    credentialHint: 'Keystore ставка са корисничким именом и лозинком; workeri је разрешавају у тренутку употребе — никада auth датотеке по чвору.',
    nameHint: 'Име налик хосту (docker.io, registry.intra); јединствено по scopeu, непроменљиво',
    addRegistry: 'Додај registry',
    addRegistryTitle: 'Додајте OCI registry',
    verify: 'Провери',
    verifyState: 'Провера',
    verified: 'Проверен',
    verifyFailed: 'Неуспешна',
    neverVerified: 'Никада проверен',
    registryInUseError: "'{name}' још има регистроване репозиторијуме — прво их обришите.",
    repositories: 'Репозиторијуми',
    repositoriesHint: 'Регистровање посматра brancheve (OCI тагове) — ништа не преузима. Refresh разрешава сваки посматрани branch и чува reflog.',
    noRepositories: 'Ниједан репозиторијум није регистрован на овом registryju.',
    registerRepository: 'Региструј репозиторијум',
    repoPath: 'Путања',
    repoPathHint: "Путања репозиторијума на registryju, нпр. 'example' или 'library/nginx'",
    branches: 'Branchevi',
    branchesHint: 'Посматрани branchevi (OCI тагови), одвојени зарезом — нпр. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Разрешен САДА: pull преузима digest на који branch показује данас.',
    refresh: 'Освежи',
    deleteRepository: 'Обриши репозиторијум',
    reflogCount: 'претходних: {n}',
    noResolutions: 'Никада освежен — још нема посматраних разрешења.',
    refreshFailed: 'Последње освежавање неуспешно ({when})',
    loadError: 'Репозиторијуме није могуће учитати.',
    reference: 'Референца',
    digest: 'Digest',
    digestHint: 'sha256:… — тачна слика, без brancha (detached)',
    size: 'Величина',
    nodes: 'Чворови',
    detached: 'detached',
    detachedHint: 'Преузета по digestu, без brancha — провера дрифта се не примењује.',
    pulledAt: 'Преузета',
    pull: 'Pull',
    pullTitle: 'Pull слике',
    pullHint: 'Pre-warming, никада предуслов: pull по branchu разрешава САДА и преузима ТАЈ digest; pull по digestu је detached.',
    pullError: 'Pull је одбијен',
    pullMode: 'Pull по',
    pullModeBranch: 'Branch (разреши сада)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Поштен подразумевани избор: као apt install, поновљен касније може дати другачију слику.',
    pullModeDigestHint: 'Тачан digest — репродуцибилност и rollback; одриче се провере дрифта.',

    // Il pattern a due pulsanti (#88, ratifica 2026-07-30 sera): "da
    // registry" è il pull guidato esistente, "da catalogo" materializza un
    // archivio oci-image pronto (la via air-gapped).
    importFromRegistry: 'Увези из registryja',
    importFromCatalog: 'Увези из каталога',
    importCatalogTitle: 'Увезите OCI слику из каталога',
    importCatalogHint: 'Air-gapped пут: спреман oci-image архив (tar/tar.gz — docker-archive или oci-archive) материјализује се у store слика са референцом catalog/<katalog>/<datoteka>@<digest>; апликације га користе као било коју другу слику. Архиви се отпремају у каталоге — овај одељак само увози.',
    importCatalogFile: 'Архив',
    importCatalogFileHint: 'Спремне oci-image датотеке изабраног каталога.',
    importCatalogNoFiles: 'Нема спремног oci-image архива у овом каталогу — отпремите један из детаља каталога.',
    importCatalogError: 'Увоз је одбијен',
    registry: 'Registry',
    repository: 'Репозиторијум',
    cacheMissing: 'Кластерски OCI кеш није конфигурисан — pullovi се одбијају док не подесите storage pool.',
    setCache: 'Подеси кеш',
    setCacheTitle: 'Конфигуришите OCI кеш',
    setCacheHint: 'ПОДРАЗУМЕВАНИ pool на нивоу кластера који чува blobove преузетих слика — scope може направити override сопственим poolom (страница Scope). Промена се не примењује у ходу и ништа не рестартује, и никада не премешта blobove: они се лењо поново појављују при следећем покретању/употреби.',
    cachePool: 'Storage pool',
    changeCache: 'Промени кеш',
    changeCacheTitle: 'Промените pool OCI кеша',
    cacheCurrent: 'OCI кеш кластера (подразумевани): {name}',
    sectionOverview: 'Преглед',
    sectionRepositories: 'Репозиторијуми',
    sectionExplore: 'Истражи',
    exploreHint: 'Удаљена претрага уживо на registryju — Docker Hub пуна (опис, преузимања, звездице), остали provideri best-effort. Изаберите резултат да прочитате његов пун опис и прегледате његове удаљене тагове; са тага можете додати референцу у TVirt репозиторијум.',
    exploreSearch: 'Претражи',
    exploreUnsupported: 'Овај provider не подржава претрагу.',
    exploreNoResult: 'Ниједан репозиторијум не одговара.',
    exploreNoTags: 'Ниједан таг не одговара на овом репозиторијуму.',
    exploreOfficial: 'Званично',
    explorePulls: 'Преузимања',
    exploreStars: 'Звездице',
    exploreUpdated: 'Ажурирано {when}',
    exploreLoadMore: 'Учитај још',
    exploreSelectHint: 'Изаберите резултат: пун опис и удаљени тагови учитавају се овде.',
    exploreNoDescription: 'Нема доступног описа од овог providera.',
    exploreTagsTitle: 'Удаљени тагови',
    exploreTagFilter: 'Претражи тагове',
    exploreAddToRepo: 'Додај у репозиторијум',
    exploreAdded: '{path}:{tag} се сада прати — погледајте одељак Репозиторијуми.',
    addBranch: 'Додај branch',
    purgeRequiredTitle: "Обрисати '{name}' и његове слике?",
    purgeRequiredBody: 'Ниједна апликација не користи овај репозиторијум, али преузете слике још постоје: брисање уклања и њихове записе, а кеширане blobove чека garbage collector.',
    purgeConfirm: 'Обриши и слике',
    providerSelectHint: 'Изаберите тип registryja: картица описује preset и намену.',
    providerDesc: {
      dockerhub: 'Јавни Docker registry: унапред попуњен URL, пуна претрага са описима и бројачима.',
      ghcr: 'GitHub Container Registry: унапред попуњен URL; налози користе personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpointi по налогу/по региону — URL се мора навести.',
      quay: 'Red Hat Quay registry: унапред попуњен URL.',
      generic: 'Self-hosted registry (Harbor, registry:2, …): https:// URL је обавезан.'
    },

    // Dialog standard (round #156): i campi del dettaglio immagine/registry
    // che le colonne non mostravano.
    layerCount: 'Layeri',
    verifiedAt: 'Последња провера',
    verifyOk: 'Исход',
    verifyMessage: 'Порука провере',

    // Model #348/R39: slika JESTE digest — sadržaj — a registry, spremište i grana su IMENA koja do njega vode.
    head: 'Head',
    heads: 'Главе по архитектури',
    listDigest: 'Дајџест листе',
    neverResolved: 'Никада разрешен',
    totalSize: 'Укупна величина',
    reflogTitle: 'Историја разрешења',
    usedBy: 'Користи га',
    usageLockfile: 'lockfile',
    usageRunning: 'у току',
    evictable: 'подложан евикцији',
    evict: 'Евикција из кеша',
    evictHeadTitle: 'Евиковати {digest}?',
    evictHeadBody: 'То је тренутно разрешење бар једног колектора: евиковати га је легитимно — то је само кеш, удаљени branch га и даље служи — али не сме да се деси грешком. Blob је ЈЕДАН: евикција празни све колекторе који га деле.',
    evictConfirm: 'Ипак га евикуј',

    arch: 'Архитектура',
    names: 'Имена',
    noNames: 'без имена',
    views: 'Прикази',
    lastView: 'последњи приказ',
    evictLastViewTitle: 'Уклонити последњу референцу на {digest}?',
    evictLastViewBody: 'Ово је последњи приказ овог садржаја: уклањањем слика престаје да постоји на TVirt-у, а бајтови ({size}) се ослобађају. То је docker image рм овог модела — није споредни ефекат, већ сама операција.',
    branchesTabHint: 'Праћене гране овог спремишта: за сваку данашње главе — по једна за архитектуру — хронологија освежавања и колико њоме именованих слика је у кешу. Освежавање је «гит фетцх» спремишта: разрешава све његове гране одједном.',
    noBranches: 'У овом спремишту се не прати ниједна грана.',
    stopObserving: 'Престани да пратиш грану',
    pullBranch: 'Преузми у кеш главу brancha (refresh разрешава, ово преузима)',
    pullDigest: 'Преузми овај digest у кеш',
    imageCount: 'Слике',
    deleteBranchPurgeTitle: 'Оставити слике из {name} без имена?',
    deleteBranchPurgeBody: 'Ниједна апликација не именује ову грану, али неке слике се достижу само преко ње: њеним брисањем остају у кешу без имена, наведене међу сликама спремишта и уклоњиве ручно.',
    deleteBranchPurgeConfirm: 'Обриши и остави слике без имена',
    imagesTabHint: 'Слике овог спремишта — садржаји, то јест digesti — видљиве и без избора гране. Слика је јединствена по кластеру: имена која до ње воде могу бити више њих.',
    noImages: 'Ниједна слика овог спремишта није материјализована у кешу.',
    deleteRepositoryTitle: 'Обрисати {name}?',
    deleteRepositoryBody: 'Спремиште и његове гране нестају са својом хронологијом. Слике остају у кешу: губе само ово име. Спремиште које именује апликација не може се обрисати.',
    provenanceCatalog: 'каталог',
    refreshedAt: 'Освежено',
    neverRefreshed: 'Никада освежено',
    sectionBranches: 'Гране',
    sectionImages: 'Слике',
    repositoriesGovernedElsewhere: 'Овде се спремишта само гледају: њихово регистровање, освежавање, праћење грана и уклањање слика ради се у одељку OCI слике.',
    gotoImages: 'Иди на OCI слике'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Подови',
    containers: 'Контејнери',
    instances: 'Instance',
    instancesTooltip: '{running} покренуто, {error} у грешци',
    placement: 'Распоређивање',
    spread: 'расподела',
    ha: 'HA',
    templateRevision: 'ревизија',
    deleting: 'Брише се',
    empty: 'Нема подова — направите апликацију (један контејнер) или под из CLI-ја (цреате-под).',
    openInstances: 'Отвори instance',
    rollingRestart: 'Постепено поновно покретање',
    scale: 'Скалирај',
    scaleTitle: 'Скалирај {name}',
    scaleHint: 'Број инстанци (0–64): навише се попуњава најнижи слободни редни број, наниже се повлачи највиши, а његови трајни подаци остају.',
    scaleError: 'Скалирање није успело',
    replicas: 'Реплике',
    deleteRunningError: '{name} је покренут — прво га зауставите.',
    deleteInstancesIntro: 'Свих {count} инстанци биће уклоњено.',
    stateRunning: 'Покренут',
    stateStopped: 'Заустављен',
    editor: {
      createTitle: 'Направи Под',
      create: 'Направи Под',
      editTitle: 'Измени Под',
      nameHint: 'DNS-1123, највише 58 знакова — instance се зову <ime>-<indeks>; непроменљиво после креирања.',
      restartPolicy: 'Политика restarta',
      restartPolicyHint_always: 'Чвор рестартује сваки изашли контејнер, са експоненцијалним backoff-om (10 с → 5 min).',
      restartPolicyHint_onFailure: 'Рестартује се само контејнер који је изашао са кодом различитим од нуле; излаз 0 мирује.',
      restartPolicyHint_never: 'Изашли контејнер остаје какав јесте — инстанца се завршава као суццеедед или фаилед.',
      grace: 'Одлагање (с)',
      graceHint: 'Граница SIGTERM → SIGKILL заустављања.',
      hostname: 'Име хоста',
      hostnameHint: 'Празно = име instance.',
      hostnameDefault: 'име instance',
      sharePid: 'Дели PID именски простор између контејнера',
      containersIntro: 'Init контејнери се извршавају до краја, редом, пре него што контејнери крену; контејнери деле мрежу instance (један IP, лоцалхост међу њима).',
      initContainers: 'Init контејнери',
      initAdd: 'Додај init контејнер',
      initHint: 'Сваки мора да изађе са 0; неуспех ставља инстанцу у грешку, а чвор га понавља са backoff-om.',
      containerAdd: 'Додај контејнер',
      atLeastOne: 'Под-у је потребан бар један контејнер.',
      duplicateNames: 'Имена контејнера морају бити јединствена у Под-у (укључујући init контејнере).',
      containerName: 'Име контејнера',
      containerInvalid: 'Овај контејнер је непотпун: име (DNS-1123), слика, монтирања на декларисане волумене, бројчани лимити и сонда.',
      command: 'Команда',
      commandHint: 'Замењује entrypoint слике — један аргумент по реду, никад схелл стринг.',
      args: 'Аргументи',
      argsHint: 'Један по реду (CMD слике ако је празно).',
      mounts: 'Монтирања',
      mountAdd: 'Додај монтирање',
      mountNoVolumes: 'Прво декларишите волумен у картици Складиште.',
      readOnly: 'само за читање',
      resources: 'Лимити',
      cpus: 'CPU',
      cpusHint: 'подман --cpus (нпр. 1.5)',
      memory: 'Меморија (MiB)',
      memoryHint: 'подман --memory',
      health: 'Сонда живости',
      healthCmd: 'Команда сонде',
      healthCmdHint: 'Чвор је извршава у контејнеру при сваком надзорном откуцају — један аргумент по реду; излаз 0 = здраво.',
      healthTimeout: 'Временско ограничење (с)',
      healthRetries: 'Покушаји',
      healthRetriesHint: 'Узастопни неуспеси пре него што чвор рестартује контејнер.',
      ips: 'Статичке адресе',
      ipsHint: 'Једна по инстанци, по редном броју — скалирање ван листе се одбија.',
      instance: 'инстанца',
      volumesHint: 'Волумени припадају Под-у; путања монтирања припада сваком контејнеру (картица Контејнери).',
      spread: 'Расподела',
      spreadHint_preferred: 'Instance на различитим чворовима кад је могуће.',
      spreadHint_required: 'Instance на различитим чворовима, иначе скалирање одбија.',
      spreadHint_none: 'Само одлучивач.',
      ha: 'Висока доступност (opt-in)',
      haHint: 'Сваки трајни део на дељеном storage-u; ако чвор умре, HA decider поново ствара instance на другом члану (аутоматски failover, као код HA VM-ова).',
      yes: 'да',
      no: 'не'
    },
    detail: {
      container: 'Контејнер',
      actions: 'Радње',
      ready: 'Спреман',
      notReady: 'Није спреман',
      restarts: 'Restarti',
      lastRestartAt: 'Последњи restart:',
      backoffUntil: 'Поновни покушај у',
      stateAbsent: 'одсутан',
      stateRunning: 'ради',
      stateTerminated: 'завршен',
      stateWaiting: 'чека',
      init: 'init',
      noInstances: 'Нема инстанци (реплике 0).',
      ha: 'HA',
      haHint: 'Аутоматски failover: ако чвор умре, HA decider поново ствара инстанцу на другом члану (сваки трајни део на дељеном storage-u).',
      authority: 'Authority (чвор)',
      homeless: 'без authority',
      homelessHint: 'Враћање из checkpoint-a изоставља authority (#380): ниједан чвор је не опслужује док не скалирате Под (макар на исти број реплика).',
      restartContainer: 'Рестартуј само овај контејнер (под остаје активан)',
      divergingHint: 'Жељено стање ове instance разликује се од подразумеваног стања Под-а (PD-P19).',
      revisionLag: 'ревизија {applied} примењена од {current}',
      updatedInstances: '{updated}/{desired} инстанци на овој ревизији'
    }
  }
}
